import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { WarningComponent } from './warning/warning.component';

const routes: Routes = [
  {
    path: ':brandSlug/educational',
    loadChildren: () => import('./edu/edu.module').then((m) => m.EduModule),
  },
  {
    path: ':brandSlug/quiz',
    loadChildren: () => import('./quiz/quiz.module').then((m) => m.QuizModule),
  },
  {
    path: ':brandSlug/survey',
    loadChildren: () => import('./quiz/quiz.module').then((m) => m.QuizModule),
  },
  {
    path: ':brandSlug/form',
    loadChildren: () => import('./form/form.module').then((m) => m.FormModule),
  },
  {
    path: ':brandSlug/instructions',
    loadChildren: () =>
      import('./instructions/instructions.module').then(
        (m) => m.InstructionsModule
      ),
  },
  {
    path: ':brandSlug/reordering',
    loadChildren: () =>
      import('./reordering/reordering.module').then((m) => m.ReorderingModule),
  },
  {
    path: ':brandSlug/golden-ticket',
    loadChildren: () =>
      import('./golden-ticket/golden-ticket.module').then(
        (m) => m.GoldenTicketModule
      ),
  },
  {
    path: ':brandSlug/brand-integrity',
    loadChildren: () =>
      import('./brand-integrity/brand-integrity.module').then(
        (m) => m.BrandIntegrityModule
      ),
  },
  {
    path: ':brandSlug/product-authentication',
    loadChildren: () =>
      import('./product-authentication/product-authentication.module').then(
        (m) => m.ProductAuthenticationModule
      ),
  },
  {
    path: ':brandSlug/spotlight',
    loadChildren: () =>
      import('./spotlight/spotlight.module').then((m) => m.SpotlightModule),
  },
  {
    path: ':brandSlug/pq201s-authentication',
    loadChildren: () =>
      import('./pq201s-authentication/pq201s-authentication.module').then(
        (m) => m.Pq201sAuthenticationModule
      ),
  },
  {
    path: 'warning/:warningType',
    component: WarningComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
